import { combineReducers, configureStore } from "@reduxjs/toolkit";
import userReducer from "./modules/UserStore";
import authReducer from "./modules/AuthStore";
import faqReducer from "./modules/FaqStore";
import requestReducer from "./modules/RequestStore";
import ciReducer from "./modules/CIStore";
import ruleReducer from "./modules/RuleStore";
import marketPlaceReducer from "./modules/MarketPlaceStore";

// redux persist
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";

import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "root",
  version: 1,
  storage,
};

const reducer = combineReducers({
  user: userReducer,
  auth: authReducer,
  faq: faqReducer,
  request: requestReducer,
  ci: ciReducer,
  rule: ruleReducer,
  marketPlace: marketPlaceReducer,
});

const persistedReducer = persistReducer(persistConfig, reducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

let persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export { store, persistor };
